<div class="login-container">
  <!-- Lado Izquierdo - Imagen -->
  <div class="left-side">
    <div class="background-image">
      <div class="crypto-cards">
        <div class="crypto-card eth">
          <div class="crypto-icon">
            <svg width="40" height="40" viewBox="0 0 40 40" fill="none">
              <circle cx="20" cy="20" r="20" fill="#627EEA"/>
              <path d="M20 4L19.6172 5.30078V25.8984L20 26.2773L29 20.8008L20 4Z" fill="white" fill-opacity="0.602"/>
              <path d="M20 4L11 20.8008L20 26.2773V4Z" fill="white"/>
              <path d="M20 28.3594L19.7656 28.6445V35.2852L20 36L29.0078 22.8867L20 28.3594Z" fill="white" fill-opacity="0.602"/>
              <path d="M20 36V28.3594L11 22.8867L20 36Z" fill="white"/>
              <path d="M20 26.2773L29 20.8008L20 15.5273V26.2773Z" fill="white" fill-opacity="0.2"/>
              <path d="M11 20.8008L20 26.2773V15.5273L11 20.8008Z" fill="white" fill-opacity="0.602"/>
            </svg>
          </div>
          <div class="crypto-info">
            <div class="crypto-name">ETH</div>
            <div class="crypto-subtitle">PNL for today</div>
          </div>
          <div class="crypto-stats">
            <div class="crypto-value">+0.0021</div>
            <div class="crypto-percentage positive">+72.5%</div>
          </div>
        </div>
        
        <div class="crypto-card usdt">
          <div class="crypto-icon">
            <svg width="40" height="40" viewBox="0 0 40 40" fill="none">
              <circle cx="20" cy="20" r="20" fill="#26A17B"/>
              <path d="M22.5 18V15.5H26V12H14V15.5H17.5V18C13.5 18.1 10.5 19 10.5 20.2C10.5 21.4 13.5 22.3 17.5 22.4V30H22.5V22.4C26.5 22.3 29.5 21.4 29.5 20.2C29.5 19 26.5 18.1 22.5 18ZM22.5 21.4V21.5C22.2 21.5 21.8 21.5 21.5 21.5H18.5C18.2 21.5 17.8 21.5 17.5 21.5V21.4C14.3 21.3 12 20.7 12 20C12 19.3 14.3 18.7 17.5 18.6V21C17.8 21 18.2 21 18.5 21H21.5C21.8 21 22.2 21 22.5 21V18.6C25.7 18.7 28 19.3 28 20C28 20.7 25.7 21.3 22.5 21.4Z" fill="white"/>
            </svg>
          </div>
          <div class="crypto-info">
            <div class="crypto-name">USDT</div>
            <div class="crypto-subtitle">PNL for today</div>
          </div>
          <div class="crypto-stats">
            <div class="crypto-value">+0.52</div>
            <div class="crypto-percentage positive">+6.1%</div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Lado Derecho - Formulario -->
  <div class="right-side">
    <div class="form-container">
      <!-- Header con Logo -->
      <div class="header">
        <div class="logo">
          <span class="logo-text">
            <img src="./assets/logo/logon.png" width="200px" alt="Logo">
          </span>
        </div>
      </div>

      <!-- Título -->
      <h1 class="title">¡Bienvenido!</h1>

      <!-- Tabs -->
      <div class="tabs">
        <button 
          class="tab" 
          [class.active]="activeTab() === 'signup'"
          (click)="setActiveTab('signup')">
          SIGN UP
        </button>
        <button 
          class="tab" 
          [class.active]="activeTab() === 'login'"
          (click)="setActiveTab('login')">
          LOG IN
        </button>
      </div>

      <!-- Formulario de Login -->
      @if (activeTab() === 'login') {
        <form [formGroup]="signupForm" (ngSubmit)="onSubmit()" class="signup-form">
          <!-- Error Message -->
          @if (errorMessage()) {
            <div class="error-message">
              <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
                <circle cx="10" cy="10" r="9" stroke="#ff4444" stroke-width="2"/>
                <path d="M10 6V10M10 14H10.01" stroke="#ff4444" stroke-width="2" stroke-linecap="round"/>
              </svg>
              <span>{{ errorMessage() }}</span>
            </div>
          }

          <!-- Email -->
          <div class="form-group">
            <label class="form-label">Email</label>
            <div class="input-wrapper" [class.valid]="signupForm.get('email')?.valid">
              <input 
                type="email" 
                formControlName="email" 
                class="form-input"
                placeholder="Enter your email" />
              <svg class="input-icon success" width="20" height="20" viewBox="0 0 20 20" fill="none">
              <circle cx="10" cy="10" r="10" fill="#77d27a"/>
              <path d="M6 10L9 13L14 7" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
            </div>
          </div>

          <!-- Password -->
          <div class="form-group">
            <label class="form-label">Password must contain 8 characters or more</label>
            <div class="input-wrapper" [class.valid]="signupForm.get('password')?.valid">
              <input 
                type="password" 
                formControlName="password" 
                class="form-input"
                placeholder="Enter your password" />
              <svg class="input-icon success" width="20" height="20" viewBox="0 0 20 20" fill="none">
              <circle cx="10" cy="10" r="10" fill="#77d27a"/>
              <path d="M6 10L9 13L14 7" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
            </div>
          </div>

          <!-- Terms Checkbox -->
          <div class="form-group checkbox-group">
            <label class="checkbox-label">
              <input 
                type="checkbox" 
                formControlName="terms" 
                class="checkbox-input" />
              <span class="checkbox-custom"></span>
              <span class="checkbox-text">Al iniciar sesión, acepto los <a href="assets/terminos.pdf" class="terms-link">Términos y Condiciones</a> y la <a href="#" class="terms-link">Declaración de Riesgo</a></span>
            </label>
          </div>

          <!-- Submit Button -->
          <button type="submit" class="submit-button" [disabled]="isLoading() || !signupForm.get('email')?.valid || !signupForm.get('password')?.valid">
            @if (isLoading()) {
              <span class="spinner"></span>
              <span>Iniciando sesión...</span>
            } @else {
              <span>Log in</span>
            }
          </button>
        </form>
      }

      <!-- Mensaje de Próximamente para Sign Up -->
      @if (activeTab() === 'signup') {
        <div class="coming-soon" routerLink="/register">
          <svg width="80" height="80" viewBox="0 0 80 80" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle cx="40" cy="40" r="40" fill="rgba(14, 64, 216, 0.1)"/>
            <path d="M40 20C28.96 20 20 28.96 20 40C20 51.04 28.96 60 40 60C51.04 60 60 51.04 60 40C60 28.96 51.04 20 40 20ZM40 55C31.72 55 25 48.28 25 40C25 31.72 31.72 25 40 25C48.28 25 55 31.72 55 40C55 48.28 48.28 55 40 55Z" fill="#0e40d8"/>
            <path d="M37.5 37.5H42.5V50H37.5V37.5ZM37.5 30H42.5V35H37.5V30Z" fill="#0e40d8"/>
          </svg>
          <h2 class="coming-soon-title">Próximamente</h2>
          <p class="coming-soon-text">La funcionalidad de registro estará disponible muy pronto. Por ahora, puedes iniciar sesión con tu cuenta existente.</p>
        </div>
      }
    </div>
  </div>
</div>

<!-- Dialog de Sesión Activa -->
@if (showSessionDialog()) {
  <div class="session-dialog-overlay" (click)="closeSessionDialog()">
    <div class="session-dialog" (click)="$event.stopPropagation()">
      <div class="dialog-icon">
        <svg width="64" height="64" viewBox="0 0 64 64" fill="none">
          <circle cx="32" cy="32" r="32" fill="rgba(220, 61, 26, 0.1)"/>
          <path d="M32 20V34M32 42H32.02" stroke="#dc3d1a" stroke-width="3" stroke-linecap="round"/>
        </svg>
      </div>
      
      <h3 class="dialog-title">Sesión Activa en Otro Dispositivo</h3>
      
      <p class="dialog-message">
        Ya existe una sesión web activa en otro dispositivo. Por favor, cierra la sesión desde ese dispositivo antes de intentar iniciar sesión aquí.
      </p>
      
      @if (sessionInfo()) {
        <div class="session-details">
          <div class="session-detail">
            <span class="detail-label">Dispositivo:</span>
            <span class="detail-value">{{ sessionInfo()!.device }}</span>
          </div>
          <div class="session-detail">
            <span class="detail-label">Última actividad:</span>
            <span class="detail-value">{{ formatDate(sessionInfo()!.fecha) }}</span>
          </div>
        </div>
      }
      
      <div class="dialog-actions">
        <button class="dialog-btn confirm" (click)="closeSessionDialog()">
          Entendido
        </button>
      </div>
    </div>
  </div>
}
